<p-dropdown #dropdown (onChange)="statusChange($event.value)" [options]="statuses" [(ngModel)]="status" placeholder="Select a Type" optionLabel="title"></p-dropdown>
